module.exports = __webpack_public_path__ + "img/license.214d89c7.jpg";